{
  "name": "scheuch-frontend",
  "version": "1.2.0",
  "scripts": {
    "build:dev": "npm run pre-build && ng build --configuration dev",
    "build:qa": "npm run pre-build && ng build --configuration qa",
    "build:prod": "npm run pre-build && ng build --configuration prod",
    "serve": "npm run icons-generate && ng serve --host 0.0.0.0 --port=4207 -o --ssl --ssl-key ./cert/localhost-key.pem --ssl-cert ./cert/localhost.pem",
    "deploy:dev": "azcopy copy \"./dist/scheuch-frontend/*\" 'https://scheuchpddevstoreweb.blob.core.windows.net/$web?sp=racwdli&st=2025-03-18T16:00:06Z&se=2026-03-19T01:00:06Z&spr=https&sv=2022-11-02&sr=c&sig=LQ97GKbbb4WMa32xhO%2FIP0fXUHEhEVYOAZYGYosvBbs%3D' --recursive=true",
    "deploy:qa": "azcopy copy \"./dist/scheuch-frontend/*\" 'https://scheuchpdteststoreweb.blob.core.windows.net/$web?sp=racwd&st=2025-04-09T08:43:56Z&se=2026-04-09T16:43:56Z&spr=https&sv=2024-11-04&sr=c&sig=FvzK4Q5ff73OEn%2F60pE4Qn9BDw695ardEguoHhhrVZU%3D' --recursive=true",
    "deploy:prod": "azcopy copy \"./dist/scheuch-frontend/*\" 'https://scheuchpdprodstoreweb.blob.core.windows.net/$web?sp=racwd&st=2025-04-13T07:16:35Z&se=2026-04-14T15:16:35Z&spr=https&sv=2024-11-04&sr=c&sig=3RjfRBqRP9h%2F7fBmyARvNUbWB1vjIj8egl6%2FDIyDhfM%3D' --recursive=true",
    "prettier": "npx prettier --write '**/*.(html|ts|js|scss)'",
    "release": "standard-version",
    "release-major": "standard-version --release-as major",
    "release-minor": "standard-version --release-as minor",
    "release-patch": "standard-version --release-as patch",
    "lint": "eslint src/app",
    "test": "ng test",
    "pre-build": "npm run icons-generate",
    "icons": "npm run icons-minify && npm run icons-generate",
    "icons-minify": "find src/assets/icons -name *.svg -type f -exec svgo {} --config svgo.js \\;",
    "icons-generate": "svg-to-ts-constants"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.0.3",
    "@angular/cdk": "^19.0.2",
    "@angular/common": "^19.0.3",
    "@angular/compiler": "^19.0.3",
    "@angular/core": "^19.0.3",
    "@angular/forms": "^19.0.3",
    "@angular/material": "^19.0.2",
    "@angular/platform-browser": "^19.0.3",
    "@angular/platform-browser-dynamic": "^19.0.3",
    "@angular/router": "^19.0.3",
    "@azure/msal-angular": "^4.0.9",
    "@azure/msal-browser": "^4.10.0",
    "@microsoft/applicationinsights-web": "^3.0.2",
    "@netural/nds": "^1.2.5",
    "@ngx-translate/core": "^16.0.3",
    "@ngx-translate/http-loader": "^16.0.0",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular": "^9.15.0",
    "angular-resizable-element": "^7.0.2",
    "date-fns": "^4.1.0",
    "lodash-es": "^4.17.21",
    "papaparse": "^5.4.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.0.4",
    "@angular-eslint/builder": "^19.0.1",
    "@angular-eslint/eslint-plugin": "^19.0.1",
    "@angular-eslint/eslint-plugin-template": "^19.0.1",
    "@angular-eslint/schematics": "^19.0.1",
    "@angular-eslint/template-parser": "^19.0.1",
    "@angular/build": "^19.0.4",
    "@angular/cli": "~19.2.7",
    "@angular/compiler-cli": "^19.0.3",
    "@eslint/eslintrc": "^3.1.0",
    "@eslint/js": "^9.14.0",
    "@netural/eslint-config-angular": "^2.0.0",
    "@tailwindcss/container-queries": "^0.1.1",
    "@tailwindcss/forms": "^0.5.3",
    "@types/jasmine": "^5.1.4",
    "@types/lodash-es": "^4.17.6",
    "@types/node": "^22.8.4",
    "@types/papaparse": "^5.3.7",
    "@typescript-eslint/eslint-plugin": "^8.10.0",
    "@typescript-eslint/parser": "^8.10.0",
    "autoprefixer": "^10.4.13",
    "eslint": "^9.12.0",
    "eslint-plugin-jsx-a11y": "^6.10.2",
    "jasmine-core": "^5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "postcss": "^8.4.21",
    "prettier": "^3.0.2",
    "prettier-plugin-tailwindcss": "^0.6.8",
    "standard-version": "^9.5.0",
    "style-dictionary": "^4.1.3",
    "svg-to-ts": "^12.0.0",
    "svgo": "^3.0.2",
    "tailwindcss": "^3.2.4",
    "typescript": "~5.6.3"
  }
}
